import $ from 'jquery';

export const init = () => {
	const $addRowBtns = $('.js-add-row'),
		$phoneInputs = $('.inp__text--phone'),
		$retenceButtons = $('.retence-forms button[type="submit"]'),
		retenceForm = $retenceButtons.closest('.retence-forms').get(0);

	let rowCount = 1;

	function onAddRow() {
		const $this = $(this),
			$form = $this.parents('.form:first'),
			addRowType = $this.data('add-row');

		rowCount++;

		//duplicate inputs
		const inputs = $form.find(`[data-add-row="${addRowType}"]`).not('.js-add-row');
		const newRow = inputs.clone();

		newRow.each((index, row) => {
			const $row = $(row);

			//clean data-add-row so we dont have dupes
			$row.removeAttr('data-add-row');
			$row.find('select, input, textarea').each((index, input) => {
				//increment name & id input attributes
				const $input = $(input);
				const id = $input.attr('id');
				const name = $input.attr('name');
				$input.attr('name', `${name}_${rowCount}`).attr('id', `${id}_${rowCount}`);
			});
		});

		newRow.insertBefore($this.parent());
	}

	function phoneInputOnKeyDown(event) {
		const val = event.target.value,
			key = event.key,
			isMaxLengthReached = removeNonDigits(val).length >= 9;

		if (!key) {
			return;
		}

		if (!isDigit(key)) {
			// allow pasting
			if (key.length == 1 && !event.ctrlKey) event.preventDefault();
			return;
		}

		if (isSelected(event.target)) {
			return;
		}
		if (isMaxLengthReached) {
			event.preventDefault();
			return;
		}

		event.target.value = removeNonWhitespaceOrDigits(event.target.value);
	}

	function phoneInputOnKeyUp(event) {
		const key = event.key;
		// allow backspace, arrows, delete
		if (!isDigit(key)) {
			return;
		}

		event.target.value = formatNumber(event.target.value);
	}

	function phoneInputOnPaste(event) {
		const number = event.target.value;

		if (number.length) {
			event.preventDefault();
			return;
		}

		phoneInputOnChange(event);
	}

	function phoneInputOnChange(event) {
		setTimeout(() => {
			let number = event.target.value;
			number = removeNonDigits(number);
			number = number.slice(0, 9);
			event.target.value = formatNumber(number);
		}, 1);
	}

	function formatNumber(number) {
		let n = removeNonDigits(number);
		n = n.replace(/\s*(\d{3})\s*/g, '$1 ');

		if (n.length > 8) {
			n = n.trim().slice(0, 11);
		}

		return n;
	}

	function removeNonWhitespaceOrDigits(number) {
		return number.replace(/[^\d\s]/g, '');
	}

	function removeNonDigits(number) {
		return number.replace(/[^\d]/g, '');
	}

	function isDigit(key) {
		return !!key && key.match(/^\d$/);
	}

	function isSelected(element) {
		return element.selectionStart < element.selectionEnd;
	}

	function retenceFormObserver() {
		// Scroll to top of retence form, when next step is loaded.
		const observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (
					mutation.type === 'attributes' &&
					mutation.target.tagName === 'BUTTON' &&
					!mutation.target.classList.contains('is-loading')
				) {
					const anchorScrollElem = retenceForm.closest('.form');
					anchorScrollElem.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			});
		});

		observer.observe(retenceForm, {
			attributes: true,
			subtree: true,
		});
	}

	$addRowBtns.on('click', onAddRow);
	$phoneInputs.on({
		keydown: phoneInputOnKeyDown,
		keyup: phoneInputOnKeyUp,
		paste: phoneInputOnPaste,
		change: phoneInputOnChange,
	});

	if (retenceForm) {
		retenceFormObserver();
	}
};
